import {
  IKeyValue,
  IUserContext,
} from '@epicuro-next/models/platform/monitoring';

/**
 * Abstraction of a service to handle context for the monitoring services
 */
export abstract class AbstractContextService {
  /**
   * Sets the user information. Pass null to clear the current user (e.g. on logout).
   * @param user
   */
  public abstract setUser(user: IUserContext | null): void;
  /**
   * Sets the tags for the app
   * @param tags
   */
  public abstract setTags(tags: IKeyValue): void;
  /**
   * Sets the release version to log
   */
  public abstract setRelease(releaseVersion: string): void;
}
